import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "subdomain", "preview"]
  static values = { baseHost: String }

  connect() {
    this.userEditedSubdomain = this.subdomainTarget.value.trim().length > 0
    this.updatePreview()
  }

  syncFromName() {
    if (!this.userEditedSubdomain) {
      this.subdomainTarget.value = this.slugify(this.nameTarget.value)
    }

    this.updatePreview()
  }

  subdomainEdited() {
    this.userEditedSubdomain = true
    this.updatePreview()
  }

  updatePreview() {
    if (!this.hasPreviewTarget) return

    const subdomain = this.subdomainTarget.value.trim() || this.subdomainTarget.placeholder.trim() || "your-workspace"
    this.previewTarget.textContent = `${subdomain}.${this.baseHostValue}`
  }

  slugify(value) {
    return value
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
  }
}
